document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('sticky-header');

  if (!header) return;

  window.addEventListener('scroll', () => {

    if (window.scrollY > 100) {
      header.classList.add('show-sticky-logo');
    } else {
      header.classList.remove('show-sticky-logo');
    }

  });

});